import { styled, Theme, CSSObject } from '@mui/material/styles';
import { drawerWidth } from 'src/shared/contexts/appContext';
import { Colors } from '../../styles/colors';

export const openedMixin = (theme: Theme): CSSObject => ({
  backgroundColor: `${Colors.PageBackground} !important`,
  color: Colors.MenuText,
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  [theme.breakpoints.down('md')]: {
    flexShrink: 1,
    boxShadow: theme.shadows[10],
  },
  overflowX: 'hidden',
  borderRight: 'none',
});

export const closedMixin = (theme: Theme): CSSObject => ({
  backgroundColor: `${Colors.PageBackground} !important`,
  color: Colors.MenuText,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(9)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
  [theme.breakpoints.down('md')]: {
    display: `none !important`,
  },
  borderRight: 'none',
});

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const listMenuStyles = {
  '&.Mui-disabled': {
    pointerEvents: 'auto',
  },
  '& .MuiListItemButton-root.active:not(.subMenuItem)': {
    backgroundColor: Colors.White,
    boxShadow: 1,
  },
  '& .subMenuText .MuiTypography-root': {
    fontSize: '0.8rem !important',
    fontWeight: 'inherit',
  },
  '.MuiSvgIcon-root': {
    color: `${Colors.MenuIcon} !important`,
  },
  '& .subMenuItem': {
    py: 0.25,
    ml: 0.8,
    position: 'relative',
    '&::after': {
      backgroundColor: Colors.LinkColor,
      content: '" "',
      height: '1rem',
      left: '1.25rem',
      opacity: '.5',
      position: 'absolute',
      top: -0.5,
      transform: 'translateY(-50%)',
      width: '1px',
    },
    '&:first-of-type::after': {
      height: '0.5rem',
      top: (thm) => thm.spacing(0.5),
    },
  },
  mx: 1,
};
